'use client';
import { dataExpTagConfig } from '@/components/product/const';
import JDIProductCard from '@/components/productCard';
import { CommonProductListWrapper } from '@/styles/product';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25217';
type Props = {
  title?: string;
  data: any[];
  headerNav?: React.ReactNode;
  trackParams: any;
  localInfo: any;
};

export default function StorePickProductList({ title, data = [], trackParams, localInfo }: Props) {
  // 需求store pick 至少4个商品
  return (
    <>
      {' '}
      {!!data?.length && data?.length >= 4 && (
        <>
          <CommonProductListWrapper
            exptag={'exp|' + EXPOSURE_RECORD.Productdetail_Storepicks_Expo}
            data-exptag-config={dataExpTagConfig}
            data-exptag-json-param={JSON.stringify(trackParams)}
          >
            {title && <p className='title'>{title}</p>}
            <div className='product-card-wrapper'>
              {/* { data.map((item: any, index: number)=> <Card key={index} data={item} />)} */}
              {data.map((item: any, index: number) => {
                const commonProductTrackParams = {
                  ...trackParams,
                  skuid: item.skuId,
                  index,
                  ratingNum: item?.commentScore,
                  SalesNum: item?.saleNum,
                  firprice: item?.realPrice,
                  secprice: item?.originalPrice,
                };
                const productData = {
                  skuId: item.skuId,
                  skuImgKeyParams: {
                    imgUrlKey: item.imageUrl,
                    width: 240,
                    height: 240,
                    domains: process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(','),
                  },
                  skuName: item?.wareName,
                  realPrice: item?.realPrice,
                  originalPrice: item?.originalPrice,
                  type: '2',
                  saleNum: item?.saleNum,
                  score: item?.commentScore,
                  shouldShowScore: true,
                  shouldShowCart: true,
                  promotions: item?.promotions || [],
                  trackingPointParams: {
                    productExpConfig: {
                      event_id: 'Productdetail_Storepicks_Products_Expo',
                      json_param: {
                        ...commonProductTrackParams,
                      },
                    },
                    productClickPoint: () => {
                      sendClickTrack.Productdetail_Storepicks_Products_Click({
                        ...commonProductTrackParams,
                      });
                    },
                    cartClickPoint: () => {
                      sendClickTrack.Productdetail_Storepicks_Products_Addtocart_Click({
                        ...commonProductTrackParams,
                      });
                    },
                  },
                  currency: localInfo?.currencySymbol,
                };
                // return <>{item.content.originalPrice}</>
                return (
                  <JDIProductCard
                    // @ts-ignore
                    productData={productData}
                    key={`${item.skuId}_${index}`}
                  />
                );
              })}
            </div>
          </CommonProductListWrapper>
        </>
      )}
    </>
  );
}
